import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) {
      localStorage.setItem("token", token);
      window.history.replaceState({}, document.title, "/dashboard");
    }
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", fontFamily: "Outfit, sans-serif" }}>
      {/* NAVBAR */}
      <nav style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "14px 40px",
        background: "#fff",
        boxShadow: "0 2px 16px rgba(108,99,255,0.08)",
        zIndex: 100,
      }}>
        <div
          style={{ fontSize: "1.3rem", fontWeight: 800, color: "#6c63ff", cursor: "pointer" }}
          onClick={() => navigate("/home")}
        >
          ⚡ LOGIMES
        </div>
        <div style={{ display: "flex", gap: "24px", fontSize: "0.95rem", fontWeight: 500, color: "#666" }}>
          <span style={{ cursor: "pointer" }} onClick={() => navigate("/home")}>🏠 Accueil</span>
          <span style={{ cursor: "pointer" }} onClick={() => navigate("/factures")}>🧾 Factures</span>
          <span style={{ cursor: "pointer" }} onClick={() => navigate("/statistics")}>📊 Statistiques</span>
          <span style={{ color: "#6c63ff", fontWeight: 700 }}>📈 Dashboard TEIF</span>
        </div>
        <button
          onClick={() => { localStorage.removeItem("token"); navigate("/"); }}
          style={{
            background: "transparent", color: "#e74c3c", border: "1.5px solid #e74c3c",
            padding: "8px 18px", borderRadius: "8px", fontWeight: 600, cursor: "pointer"
          }}
        >
          Déconnexion
        </button>
      </nav>

      {/* IFRAME MIDDLEWARE DASHBOARD */}
      <iframe
        src={`${process.env.REACT_APP_API_URL}/dashboard`}
        title="Dashboard Fiscal TEIF"
        style={{
          flex: 1,
          border: "none",
          width: "100%",
        }}
      />
    </div>
  );
}

export default Dashboard;


